import { createContext, useState } from 'react';
import api from 'services/api';

export const RecursosContext = createContext();

export const RecursosProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [upsertLoading, setUpsertLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const getRecursos = async ({ cb = null }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get(`/Producao/Recursos`);
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const upsertRecurso = async ({ data, rotina, cb = null }) => {
    try {
      setUpsertLoading(true);
      await api.post(`/Grid/Manutencao`, { data, rotina });
      if (cb) {
        cb?.();
      }
    } catch (error) {
    } finally {
      setUpsertLoading(false);
    }
  };

  const deleteRecurso = async ({ rotina, id, cb }) => {
    try {
      const params = { rotina, id };
      setDeleteLoading(true);
      await api.delete('/Grid', { params });
      if (cb) {
        cb?.();
      }
    } catch (error) {
    } finally {
      setDeleteLoading(false);
    }
  };

  return (
    <RecursosContext.Provider
      value={{
        getLoading,
        getRecursos,
        upsertLoading,
        upsertRecurso,
        deleteLoading,
        deleteRecurso,
      }}
    >
      {children}
    </RecursosContext.Provider>
  );
};
